import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a030000"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    title: _ctx.title,
    icon: _ctx.icon
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass('bc-exp' + (_ctx.isOpen ? ' open' : ''))
      }, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeExpander && _ctx.changeExpander(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-angle-up" })
        ]),
        _createElementVNode("div", {
          id: 'bcexp-' + _ctx.expanderId
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 8, _hoisted_1)
      ], 2)
    ]),
    _: 3
  }, 8, ["title", "icon"]))
}